import { render, staticRenderFns } from "./GraphHerbicideTwos.vue?vue&type=template&id=4097d5df&"
import script from "./GraphHerbicideTwos.vue?vue&type=script&lang=js&"
export * from "./GraphHerbicideTwos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports